import reducers from 'reducers'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'

import thunk from 'redux-thunk'

const isProduction = process.env.NODE_ENV === 'production'

let enhancer

if (!isProduction) {
  enhancer = composeWithDevTools(applyMiddleware(thunk))
} else {
  enhancer = applyMiddleware(thunk)
}

export const store = createStore(reducers, enhancer)

export type AppDispatch = typeof store.dispatch
